import { TipoSuministroInmuebleEnum, type AddFacturaInmuebleModel } from '@api/api';

export class AddFacturaInmueble implements AddFacturaInmuebleModel {

  Fecha: Date = new Date();
  Importe: number = 0;
  RutaTemporal: string = '';
  TipoSuministro: TipoSuministroInmuebleEnum = TipoSuministroInmuebleEnum.Luz;
  
  constructor(data?: Partial<AddFacturaInmueble>) {
    Object.assign(this, data);
  }

  public setRutaTemporal(ruta: string){
    this.RutaTemporal = ruta;
  }

}